import styles from "../styles/index.module.css";


export default function Index({ enter }) {
return (
<div className={styles.centered}>
<h1>Powerlifting Judge</h1>
<p>You’re a judge at a lifting competition. Lifters are coming fast.</p>
<p>To catch up, solve plate math problems as fast as possible.</p>
<button onClick={enter}>Enter the Meet</button>
</div>
);
}